// extracted by mini-css-extract-plugin
export default {"common-fullscreen-header":"common-fullscreen-header__rq2y7","__align-start":"__align-start__rq2y7","__align-end":"__align-end__rq2y7","control__button":"control__button__rq2y7"};